import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column'
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';
import {AggregationSelector} from "../../stocks/models/aggregation-selector";

export class OnGroupingEventArgs<T extends Slick.SlickData> {
    constructor(public readonly column: ISlickGridColumn<T>, public readonly command: string, public readonly aggregation?: AggregationSelector[]) {
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/on-grouping-event-args.ts